goog.provide("shadow.js.shim.module$$mui$material$ButtonGroup$default");
shadow.js.shim.module$$mui$material$ButtonGroup$default = shadow.js.shim.module$$mui$material$ButtonGroup.default;
